import { TOGGLE_OPEN_AUTH_MODAL } from "@actions/account/"
import { VALIDATE_EMAIL } from "@constants"

export const toggleAuthModal = () => dispatch => dispatch({ type: TOGGLE_OPEN_AUTH_MODAL })

export const validateEmail = email => VALIDATE_EMAIL.test(email)
